import React from 'react';
import { useState, useEffect } from 'react';
import { Divider } from 'antd';
import { useParams } from 'react-router-dom';
import EmployerCard from '../../Components/EmployerCard';
import usePortalService from '../../services/PortalService';
import ImagesViewer from '../../Components/ImageElements/ImagesViewer';
import { TextPreparator } from '../../utils/TextPreparator';
import { Company, Vacancy } from '../../types';
import { LoaderWithTimer } from '../../Components/LoaderWithTimer';
import { VacancyCard } from '../../Components/VacancyCards/VacancyCard';

let companyId: string;
export const BaseCompanyPage = () => {
    const { mainInformationForProfile } = usePortalService();

    const params = useParams();
    companyId = params.id as string;

    const [company, setCompany] = useState<Company>();
    const [name, setName] = useState('');
    const [address, setAddress] = useState('');
    const [link, setLink] = useState('');
    const [linkLabel, setLinkLabel] = useState('');
    const [description, setDescription] = useState('');
    const [vacancies, setVacancies] = useState<Vacancy[]>([]);
    const [imagesIds, setImageIds] = useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        mainInformationForProfile(companyId).then(result => {
            if (result.success) {
                setCompany(result.company);
                setName(result.company.name);
                setAddress(result.company.address);
                setLinkLabel(result.company.link);
                if (result.company.link.includes("http")) {
                    setLink(result.company?.link);
                } else {
                    setLink("https://"+result.company?.link);
                }
                setDescription(TextPreparator.prepare(result.company.description));
                setVacancies(result.company.vacancies);
                setImageIds(result.company.imagesIds);
            }
        }).catch((error) => {
            setHasError(true);
            console.log(error)
        }).finally(() => {
            setIsLoading(false);
        });
    }, []);

    return (
        <>
            <div className="left-page-container">
                <div className="left-page-content" >
                    <h1 style={{ paddingBottom: '8px' }}> {name} </h1>
                    <h2 className="address" style={{ paddingBottom: '4px' }}> {address}  </h2>
                    <a href={link} className="gray-link" target="_blank" rel="noreferrer"> {linkLabel} </a>
                    <div 
                        dangerouslySetInnerHTML={{ __html: description }} 
                        style={{ paddingTop: '16px', maxWidth: '86.8%' }}
                    />
                    <Divider />
                    <h3 style={{marginBottom:'16px'}}> Активные вакансии и стажировки компании </h3>
                    {(vacancies.length == 0 && !hasError) && <p> У работодателя пока нет активных вакансий. </p>}
                    {(!isLoading && !hasError) ? vacancies.map(vacancy => (
                        <VacancyCard 
                            vacancy={vacancy}
                            key={vacancy.id}
                        />
                    )) : (Array.from({length: 5}).map((_, index) => 
                        <LoaderWithTimer key={index} isLoading={isLoading} skeletonStyle="vacancy" />)
                    )}
                    {hasError && <p>Произошла ошибка при загрузке. Пожалуйста, попробуйте обновить страницу.</p>}
                </div>
                <div className="right-page-content d-none d-md-block">
                    <EmployerCard company={company as Company} />
                    {(imagesIds?.length > 0) &&
                    <ImagesViewer imagesIds={imagesIds} type={'company'}/>}
                </div>
            </div>
        </>
    );
};